import { render, staticRenderFns } from "./IndexSteps.vue?vue&type=template&id=9597d19c&scoped=true"
import script from "./IndexSteps.vue?vue&type=script&lang=js"
export * from "./IndexSteps.vue?vue&type=script&lang=js"
import style0 from "./IndexSteps.vue?vue&type=style&index=0&id=9597d19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9597d19c",
  null
  
)

export default component.exports